require('./aggregatorCardBox.scss');

import React from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import Immutable from 'immutable';

import { withRouter, Link } from 'react-router-dom';

// @components
import { AggregatorGenericBox } from '../aggregatorGenericBox/aggregatorGenericBox';
import { AggregatorCardDetails } from 'components/aggregator/aggregatorDetails/aggregatorCardDetails/aggregatorCardDetails';
import CardsCreditBalanceBar from 'components/cards/cardsCreditBalanceBar/cardsCreditBalanceBar';
import { LoadingSection } from 'commonsComponents/loadingSection';

// @commons
import OKTooltip from 'components/commons/OKTooltip/OKTooltip';

// @helpers
import { getLastNChars } from 'utilities/stringHelper';
import { formatDate } from 'utilities/dateHelper';
import { sendTextToClipBoard } from 'commonsUtilities/clipBoardHelper';
import { getBrandImage } from 'utilities/aggregator/aggregatorCardHelper';

// @constants
import cardType from 'constants/aggregator/cardType';

const { FormattedText } = require('core/i18n').i18n;

class AggregatorCardBox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false,
    };

    this.renderHeader = this.renderHeader.bind(this);
    this.renderBody = this.renderBody.bind(this);
  }

  handleOnToggle = isExpanded => {
    this.setState({ isExpanded });
  };

  handleCopyIbanToClipBoard() {
    sendTextToClipBoard(this.props.number);
  }

  buildTooltipContent(iban) {
    return (
      <span>
        {iban}
        <button
          className="icon__tooltip icon-copiar"
          onClick={this.handleCopyIbanToClipBoard}
        ></button>
      </span>
    );
  }

  renderExpanded = () => {
    const { id, alias, number, brandCard, type, available, disposed, limitCredit, active } =
      this.props;

    const numberFormatted = (
      <span className="aggregator-cards-box-header__iban">{getLastNChars(`${number}`)}</span>
    );
    const tooltipContent = this.buildTooltipContent(number);

    const card = {
      type: cardType[(type || '').toLowerCase()] || cardType.credito,
      cancelled: active,
      availableBalance: available,
      balanceDrawn: disposed,
      limit: limitCredit,
    };

    return (
      <section>
        <div className="aggregator-cards-box-header--expanded__main">
          <div className="row">
            <div className="col-xs-4">
              <div className="aggregator-cards-box-header--expanded__img-div">
                <img
                  className={'aggregator-cards-box-header--expanded__img-div__img'}
                  src={getBrandImage(brandCard)}
                />
              </div>
            </div>
            <div className="col-xs-8 aggregator-cards-box-header--expanded__info">
              <div>
                <Link
                  className="aggregator-cards-box-header__alias"
                  to={'/myprofile/global/entities/cards/' + id}
                >
                  {alias}
                </Link>
              </div>
              <div>
                <OKTooltip
                  content={tooltipContent}
                  offset={[80, 10]}
                  placement="bottom"
                  target={numberFormatted}
                />
              </div>
              <div className="aggregator-cards-box-header__balance">
                <CardsCreditBalanceBar immCard={Immutable.fromJS(card)} showTooltip={false} />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  renderCollapsed = () => {
    const { id, alias, number, brandCard, type, available, disposed, limitCredit, active } =
      this.props;

    const numberFormatted = (
      <span className="aggregator-cards-box-header__iban">{getLastNChars(`${number}`)}</span>
    );
    const tooltipContent = this.buildTooltipContent(number);

    const card = {
      type: cardType[(type || '').toLowerCase()] || cardType.credito,
      cancelled: active,
      availableBalance: available,
      balanceDrawn: disposed,
      limit: limitCredit,
    };

    return (
      <React.Fragment>
        <section>
          <div className="aggregator-cards-box-header__main">
            <div className={'aggregator-cards-box-header__img-div'}>
              <img
                className={'aggregator-cards-box-header__img-div__img'}
                src={getBrandImage(brandCard)}
              />
            </div>
            <div className="aggregator-cards-box-header__info">
              <div>
                <Link
                  className="aggregator-cards-box-header__alias"
                  to={'/myprofile/global/entities/cards/' + id}
                >
                  {alias}
                </Link>
              </div>
              <div>
                <OKTooltip
                  content={tooltipContent}
                  offset={[80, 10]}
                  placement="bottom"
                  target={numberFormatted}
                />
              </div>
            </div>
          </div>
        </section>
        <div className="aggregator-cards-box-header__balance">
          <CardsCreditBalanceBar immCard={Immutable.fromJS(card)} showTooltip={false} />
        </div>
      </React.Fragment>
    );
  };

  renderHeader() {
    const { id, lastUpdate, type, history } = this.props;
    const { isExpanded } = this.state;

    const headerClassName = className('aggregator-cards-box-header', {
      'aggregator-cards-box-header--expanded': isExpanded,
    });

    return (
      <div
        className={headerClassName}
        id={id}
        onClick={() => history.push(`/myprofile/global/entities/cards/${id}`)}
      >
        {isExpanded && this.renderExpanded()}
        {!isExpanded && this.renderCollapsed()}
        <section>
          <div className={`${headerClassName}__subtype`}>
            <span className={`${headerClassName}__subtype__type`}>
              <FormattedText
                value={`aggregatorCardsDetails-${
                  cardType[(type || '').toLowerCase()] || cardType.credito
                }`}
              />
            </span>
            <span>-</span>
            <span className={`${headerClassName}__subtype__date`}>
              <FormattedText
                value="aggregatorCardsDetails-lastUpdate"
                injectedStrings={[formatDate(lastUpdate)]}
              />
            </span>
          </div>
        </section>
      </div>
    );
  }

  renderBody() {
    const { details, id, isTinkAggregator } = this.props;

    if (!details) return <LoadingSection />;

    return (
      <div className="aggregator-cards-box-body">
        <AggregatorCardDetails
          details={details}
          productId={id}
          isTinkAggregator={isTinkAggregator}
        />
      </div>
    );
  }

  render() {
    const { onExpand, id } = this.props;

    return (
      <AggregatorGenericBox
        header={this.renderHeader()}
        body={this.renderBody()}
        onExpand={onExpand}
        id={id}
        onToggle={this.handleOnToggle}
      />
    );
  }
}

AggregatorCardBox.propTypes = {
  number: PropTypes.string,
  id: PropTypes.string,
  active: PropTypes.bool,
  type: PropTypes.string,
  alias: PropTypes.string,
  disposed: PropTypes.object,
  history: PropTypes.object.isRequired,
  available: PropTypes.object,
  limitCredit: PropTypes.object,
  expired: PropTypes.bool,
  expirationDate: PropTypes.string,
  lastUpdate: PropTypes.string,
  details: PropTypes.object,
  brandCard: PropTypes.object,
  onExpand: PropTypes.func,
  isTinkAggregator: PropTypes.bool,
};

AggregatorCardBox.defaultTypes = {
  type: 'C',
};

export default withRouter(AggregatorCardBox);
